import {
  H2_PROJECT_IMG01,
  H2_PROJECT_IMG02,
  H2_PROJECT_IMG03,
  H3_PROJECT_IMG02,
  H3_PROJECT_IMG03,
  H3_PROJECT_IMG04,
  H5_PROJECT_IMG01,
  H5_PROJECT_IMG02,
  H5_PROJECT_IMG03,
  H5_PROJECT_IMG04,
  H5_PROJECT_IMG05,
  PROJECT_IMG01,
  PROJECT_IMG02,
  PROJECT_IMG03,
} from "../lib/assets";

export const PROJECT_LIST_TWO = [
  {
    id: 1,
    img: H2_PROJECT_IMG01,
    href: "/project-details",
    title: "Finance Consultancy",
    tag: "Advisory",
  },
  {
    id: 2,
    img: H2_PROJECT_IMG02,
    href: "/project-details",
    title: "Finance Consultancy",
    tag: "Advisory",
  },
  {
    id: 3,
    img: H2_PROJECT_IMG03,
    href: "/project-details",
    title: "Finance Consultancy",
    tag: "Advisory",
  },
];

export const PROJECT_LIST_THREE = [
  {
    id: 1,
    href: "/project-details",
    src: H3_PROJECT_IMG02,
  },
  {
    id: 2,
    href: "/project-details",
    src: H3_PROJECT_IMG02,
  },
  {
    id: 3,
    href: "/project-details",
    src: H3_PROJECT_IMG03,
  },
  {
    id: 4,
    href: "/project-details",
    src: H3_PROJECT_IMG04,
  },
];

export const PROJECT_LIST_FOUR = [
  {
    id: 1,
    href: "/project-details",
    src: H5_PROJECT_IMG01,
    title: "Illustration Design",
    subtitle: "Creative Work",
  },
  {
    id: 2,
    href: "/project-details",
    src: H5_PROJECT_IMG02,
    title: "Design & Development",
    subtitle: "Planing",
  },
  {
    id: 3,
    href: "/project-details",
    src: H5_PROJECT_IMG03,
    title: "Marketing Consultancy",
    subtitle: "Development",
  },
  {
    id: 4,
    href: "/project-details",
    src: H5_PROJECT_IMG04,
    title: "Digital Marketing",
    subtitle: "Skill Development",
  },
  {
    id: 5,
    href: "/project-details",
    src: H5_PROJECT_IMG05,
    title: "Strategic Planning",
    subtitle: "Marketing",
  },
];

export const PROJECT_LIST_ONE = [
  {
    id: 1,
    href: "/project-details",
    tag: "Achievment",
    tagHref: "/project",
    src: PROJECT_IMG01,
    title: "Based on your Correct situation",
  },
  {
    id: 2,
    href: "/project-details",
    tag: "Business Strategy",
    tagHref: "/project",
    src: PROJECT_IMG02,
    title: "Best mortgage rates guaranteed.",
  },
  {
    id: 3,
    href: "/project-details",
    tag: "Investment",
    tagHref: "/project",
    src: PROJECT_IMG03,
    title: "Investment Policy For New Project",
  },
  {
    id: 4,
    href: "/project-details",
    tag: "Achievment",
    tagHref: "/project",
    src: PROJECT_IMG01,
    title: "Based on your Correct situation",
  },
];
